(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tooltip"] && !Shopify.designMode) return;
  try {
    // Touch-friendly: toggle on tap
  document.querySelectorAll('.tooltip-block__trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
    });
  });

  // Close when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.tooltip-block')) {
      document.querySelectorAll('.tooltip-block__trigger[aria-expanded="true"]').forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
